import styled from 'styled-components'

const ActionsResponding = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
  height: 44px;
  margin-bottom: 15px;
`

export default ActionsResponding
